import React from 'react';
import './ToggleSwitch.css';

// Reusable iOS-style pill switch -- the same visual NavMenu.js's
// notification toggle originally built inline (see that file's git
// history); extracted here so a second on/off switch elsewhere (the
// admin panel's activation-eligible toggle) can't drift into its own
// separate copy of the same CSS. Purely presentational: the caller owns
// all state (checked/busy/disabled) and just gets told when a click
// wants the value flipped -- it never applies the change itself.
const ToggleSwitch = ({ label, checked, onChange, busy, disabled }) => (
  <div
    className={`toggle-switch-row${busy ? ' toggle-switch-row--busy' : ''}${
      disabled ? ' toggle-switch-row--disabled' : ''
    }`}
    onClick={() => {
      if (busy || disabled) return;
      onChange(!checked);
    }}
    role="switch"
    aria-checked={checked}
    tabIndex={0}
    aria-disabled={busy || disabled}
    onKeyPress={(e) => {
      if (e.key !== 'Enter' || busy || disabled) return;
      onChange(!checked);
    }}
  >
    {label && <span className="toggle-switch-row__label">{label}</span>}
    <span className={`toggle-switch${checked ? ' toggle-switch--on' : ''}`}>
      <span className="toggle-switch__thumb" />
    </span>
  </div>
);

export default ToggleSwitch;
